import React from "react";
import { useParams } from "react-router-dom";
import { Form, Input, Space, Button, Radio, notification } from "antd";
import { TenantService } from "../../../../Services";
import { formateStringToKey } from "../../Service";

const layout = {
	labelCol: { span: 10 },
	wrapperCol: { span: 12 }
};

const tailLayout = {
	wrapperCol: { offset: 6, span: 18 }
};

export const AddUpdateSectionForm = ({ closeForm, mode, section }) => {
	const { tenantName } = useParams();

	const [form] = Form.useForm();

	const onFinish = async values => {
		if (mode === "add") {
			const { data } = await TenantService.createTenantSection({
				tenantName,
				section: {
					...values
				}
			});
			if (data.status === 200) {
				form.resetFields();
				notification.success({ message: "Section created successfully" });
				closeForm();
				return;
			}
			notification.error({ message: "Failed to create section" });
		}

		if (mode === "update") {
			const { data } = await TenantService.updateTenantSection({
				tenantName,
				section: {
					...section,
					...values
				}
			});
			if (data.status === 200) {
				form.resetFields();
				notification.success({ message: "Section updated successfully" });
				closeForm();
				return;
			}
			notification.error({ message: "Failed to update section" });
		}
	};

	const onValuesChange = changedValues => {
		if (changedValues.Label) {
			const label = changedValues.Label;

			form.setFieldsValue({
				ApiTag: formateStringToKey(label), // generate `apiTag`
				Key: formateStringToKey(label) // generate `key`
			});
		}
	};

	return (
		<Form
			initialValues={section}
			{...layout}
			form={form}
			onFinish={onFinish}
			onValuesChange={onValuesChange}
			style={{
				maxWidth: 500,
				border: "1px solid #e8e8e8",
				padding: "20px",
				borderRadius: "8px"
			}}
		>
			<Form.Item name="Label" label="Label" rules={[{ required: true }]}>
				<Input />
			</Form.Item>
			<Form.Item name="ApiTag" label="API Tag" rules={[{ required: true }]}>
				<Input />
			</Form.Item>
			<Form.Item name="Key" label="Key" rules={[{ required: true }]}>
				<Input />
			</Form.Item>
			<Form.Item name="FilterType" label="Default Type" rules={[{ required: true }]} initialValue={true}>
				<Radio.Group>
					<Radio value={true}>Union</Radio>
					<Radio value={false}>Intersection</Radio>
				</Radio.Group>
			</Form.Item>
			<Form.Item name="_Show_FilterType" label="Show to Client" rules={[{ required: true }]} initialValue={false}>
				<Radio.Group>
					<Radio value={true}>Yes</Radio>
					<Radio value={false}>No</Radio>
				</Radio.Group>
			</Form.Item>
			<Form.Item {...tailLayout}>
				<Space>
					<Button type="primary" htmlType="submit">
						Submit
					</Button>
					<Button htmlType="button" onClick={() => form.resetFields()}>
						Reset
					</Button>
				</Space>
			</Form.Item>
		</Form>
	);
};

export default AddUpdateSectionForm;
